import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "filename"]

  connect() {
    // Define the preventDefaults function properly
    const preventDefaults = (e) => {
      e.preventDefault()
      e.stopPropagation()
    }
    
    // Add events to the element (drop zone)
    ['dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.element.addEventListener(eventName, preventDefaults, false)
    })
    
    this.element.addEventListener('dragover', this.highlight.bind(this), false)
    this.element.addEventListener('dragleave', this.unhighlight.bind(this), false)
    this.element.addEventListener('drop', this.handleDrop.bind(this), false)
    
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('change', this.handleChange.bind(this))
    }
  }
  
  preventDefaults(e) {
    e.preventDefault()
    e.stopPropagation()
  }
  
  highlight(e) {
    this.preventDefaults(e)
    this.element.classList.add('border-primary', 'bg-gray-50')
    this.element.classList.remove('border-riseup-inputs-border-default')
  }
  
  unhighlight(e) {
    this.preventDefaults(e)
    this.element.classList.remove('border-primary', 'bg-gray-50')
    this.element.classList.add('border-riseup-inputs-border-default')
  }
  
  handleDrop(e) {
    this.preventDefaults(e)
    this.unhighlight(e)
    
    const dt = e.dataTransfer
    const files = dt.files
    
    if (this.hasInputTarget && files.length > 0) {
      this.inputTarget.files = files
      this.updateFilename(files[0].name)
    }
  }
  
  handleChange(e) {
    if (e.target.files.length > 0) {
      this.updateFilename(e.target.files[0].name)
    }
  }
  
  updateFilename(name) {
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = name
      this.filenameTarget.classList.remove('hidden')
    }
  }
}